import { ChevronRight, Home } from 'lucide-react';
import { useMemo } from 'react';
import { useEditorStore } from '../../store/editorStore';

export function CompositionBreadcrumbs() {
  const project = useEditorStore((state) => state.project);
  const open = useEditorStore((state) => state.openComposition);
  const path = useMemo(() => {
    const values = [];
    let current = project.compositions[project.activeCompositionId];
    while (current) {
      values.unshift(current);
      current = current.parentCompositionId ? project.compositions[current.parentCompositionId] : undefined!;
    }
    return values;
  }, [project]);
  return <div className="breadcrumbs"><Home size={12} /><span>{project.name}</span>{path.map((composition, index) => <span className="breadcrumb-part" key={composition.id}>{index > 0 || <ChevronRight size={11} />}<button className={index === path.length - 1 ? 'is-current' : ''} onClick={() => open(composition.id)}>{composition.name}</button>{index < path.length - 1 && <ChevronRight size={11} />}</span>)}</div>;
}
